"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _Credentials = _interopRequireDefault(require("../Credentials"));
var _types = require("../../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t; i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw (o = s, n.arg); n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } if ("throw" === p.type) { o = s; n.method = "throw"; n.arg = p.arg; } } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, void maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]); if (2 in t) { e.finallyLoc = t[2]; e.afterLoc = t[3]; } this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal"; delete e.arg; t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }]; t.forEach(pushTryEntry, this); this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : void (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";

/**
 * ? Class properties marked as not in use but `this` is assigned to variable `that`
 * ? due to scoping issues with promise resolving to use these properties
 */
var AuthService = exports["default"] = /*#__PURE__*/function () {
  /**
   * @private
   * @param {AuthConfigProps} config
   */

  /**
   * @private
   * @param {CognitoUserPool} client
   */

  /**
   * @private
   * @param {ReturnType<AuthService["signin"]> | null}
   */

  /**
   * @private
   * @param {string | undefined} email
   * When a user has entered the email address from the forgot password form or the confirm account form
   * it is stored here so that the user can be sent a code to reset their password,
   * I opted for this instead of creating a context for one single value or rejigging my entire
   * component structure and state management within the Auth component - IS
   * @default {undefined}
   */

  /**
   * @private
   * @param {string | undefined} password
   * This is only stored when the user has not been confirmed as it will need to be used later to sign the user in
   * after they have confirmed their account
   * I have opted for this instead of creating a context for one single value or rejigging my entire
   * component structure and state management within the Auth component - IS
   * @default {undefined}
   */

  /**
   * @private
   * @param {boolean} _confirmSignUp
   * Controls whether the confirmation code is to verify account or for MFA
   * @default {false}
   */

  function AuthService(config) {
    var _this = this;
    _classCallCheck(this, AuthService);
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */
    _defineProperty(this, "currentSession", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var that;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            that = _this; // Purposely not calling the reject method here because we don't need a console error
            if (_this._client) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", Promise.reject(new Error("No User Pool in the configuration.")));
          case 3:
            _context.next = 5;
            return new Promise(function (res, rej) {
              that.currentUserPoolUser().then(function (user) {
                that._userSession(user).then(function (session) {
                  res(session);
                  return;
                })["catch"](function (e) {
                  rej(e);
                  return;
                });
              })["catch"](function (e) {
                rej(e);
                return;
              });
            });
          case 5:
            return _context.abrupt("return", _context.sent);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    // Intialise private variables
    this._config = config;
    var _this$_config = this._config,
      UserPoolId = _this$_config.USER_POOL_ID,
      ClientId = _this$_config.APP_CLIENT_ID;
    this._client = new _amazonCognitoIdentityJs.CognitoUserPool({
      UserPoolId: UserPoolId,
      ClientId: ClientId
    });
    this._pendingSignIn = null;
    this._email = undefined;
    this._password = undefined;
    this._confirmSignUp = false;
    this._inflightSessionPromiseCounter = 0;
    this._inflightSessionPromise = undefined;
    this._storage = undefined;
    this._storageSync = Promise.resolve();
    this._Credentials = new _Credentials["default"](config);
  }
  _createClass(AuthService, [{
    key: "createCognitoUser",
    value: function createCognitoUser(username) {
      var userData = {
        Username: username,
        Pool: this._client
      };
      userData.Storage = this._storage;
      var user = new _types.CognitoUser(userData);
      return user;
    }
  }, {
    key: "cleanCachedItems",
    value: function () {
      var _cleanCachedItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this._Credentials.clear();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function cleanCachedItems() {
        return _cleanCachedItems.apply(this, arguments);
      }
      return cleanCachedItems;
    }()
  }, {
    key: "cleanUpInvalidSession",
    value: function () {
      var _cleanUpInvalidSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(user) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              user.signOut();
              _context3.prev = 1;
              _context3.next = 4;
              return this.cleanCachedItems();
            case 4:
              _context3.next = 9;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", this.isErrorWithMessage(_context3.t0) && _context3.t0.message === "Failed to clear cached items");
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 6]]);
      }));
      function cleanUpInvalidSession(_x) {
        return _cleanUpInvalidSession.apply(this, arguments);
      }
      return cleanUpInvalidSession;
    }()
  }, {
    key: "isErrorWithMessage",
    value: function isErrorWithMessage(err) {
      return _typeof(err) === "object" && Object.prototype.hasOwnProperty.call(err, "message");
    }

    // Session revoked by another app
  }, {
    key: "isTokenRevokedError",
    value: function isTokenRevokedError(err) {
      return this.isErrorWithMessage(err) && err.message === "Access Token has been revoked";
    }
  }, {
    key: "isRefreshTokenRevokedError",
    value: function isRefreshTokenRevokedError(err) {
      return this.isErrorWithMessage(err) && err.message === "Refresh Token has been revoked";
    }
  }, {
    key: "isUserDisabledError",
    value: function isUserDisabledError(err) {
      return this.isErrorWithMessage(err) && err.message === "User is disabled.";
    }
  }, {
    key: "isUserDoesNotExistError",
    value: function isUserDoesNotExistError(err) {
      return this.isErrorWithMessage(err) && err.message === "User does not exist.";
    }
  }, {
    key: "isRefreshTokenExpiredError",
    value: function isRefreshTokenExpiredError(err) {
      return this.isErrorWithMessage(err) && err.message === "Refresh Token has expired";
    }
  }, {
    key: "isSessionInvalid",
    value: function isSessionInvalid(err) {
      return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err);
    }
  }, {
    key: "attributesToObject",
    value: function attributesToObject(attributes) {
      var _this2 = this;
      var obj = {};
      if (attributes) {
        attributes.map(function (attribute) {
          if (attribute.Name === "email_verified" || attribute.Name === "phone_number_verified") {
            obj[attribute.Name] = _this2.isTruthyString(attribute.Value) || attribute.Value === true;
          } else {
            obj[attribute.Name] = attribute.Value;
          }
        });
      }
      return obj;
    }
  }, {
    key: "isTruthyString",
    value: function isTruthyString(value) {
      return typeof value.toLowerCase === "function" && value.toLowerCase() === "true";
    }

    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */
  }, {
    key: "confirmSignIn",
    value: (function () {
      var _confirmSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(user, code, mfaType) {
        var _this3 = this;
        var clientMetadata;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (code) {
                _context5.next = 2;
                break;
              }
              throw new Error("Empty code");
            case 2:
              clientMetadata = {};
              _context5.next = 5;
              return new Promise(function (resolve, reject) {
                user.sendMFACode(code, {
                  onSuccess: function () {
                    var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(session) {
                      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while (1) switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return _this3._Credentials.clear();
                          case 3:
                            _context4.next = 5;
                            return _this3._Credentials.set(session);
                          case 5:
                            _context4.next = 9;
                            break;
                          case 7:
                            _context4.prev = 7;
                            _context4.t0 = _context4["catch"](0);
                          case 9:
                            _context4.prev = 9;
                            resolve(user);
                            return _context4.finish(9);
                          case 12:
                          case "end":
                            return _context4.stop();
                        }
                      }, _callee4, null, [[0, 7, 9, 12]]);
                    }));
                    function onSuccess(_x5) {
                      return _onSuccess.apply(this, arguments);
                    }
                    return onSuccess;
                  }(),
                  onFailure: function onFailure(err) {
                    reject(err);
                  }
                }, mfaType, clientMetadata);
              });
            case 5:
              return _context5.abrupt("return", _context5.sent);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function confirmSignIn(_x2, _x3, _x4) {
        return _confirmSignIn.apply(this, arguments);
      }
      return confirmSignIn;
    }()
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */
    )
  }, {
    key: "confirmSignUp",
    value: (function () {
      var _confirmSignUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(username, code, options) {
        var _this4 = this;
        var user, forceAliasCreation, clientMetadata;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (this._client) {
                _context6.next = 2;
                break;
              }
              throw new Error("No user pool");
            case 2:
              if (username) {
                _context6.next = 4;
                break;
              }
              throw new Error("Empty username");
            case 4:
              if (code) {
                _context6.next = 6;
                break;
              }
              throw new Error("Empty code");
            case 6:
              user = this.createCognitoUser(username);
              forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
              clientMetadata = {};
              _context6.next = 11;
              return new Promise(function (resolve, reject) {
                user.confirmRegistration(code, forceAliasCreation, function (err, data) {
                  if (err) {
                    reject(err);
                  } else {
                    var autoSignIn = _this4.isTrueStorageValue("auto-sign-in");
                    if (autoSignIn) {
                      _this4._storage.removeItem("auto-sign-in");
                    }
                    resolve(data);
                  }
                }, clientMetadata);
              });
            case 11:
              return _context6.abrupt("return", _context6.sent);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function confirmSignUp(_x6, _x7, _x8) {
        return _confirmSignUp.apply(this, arguments);
      }
      return confirmSignUp;
    }())
  }, {
    key: "isTrueStorageValue",
    value: function isTrueStorageValue(value) {
      var item = this._storage.getItem(value);
      return item ? item === "true" : false;
    }

    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */
  }, {
    key: "_resendSignUp",
    value: function _resendSignUp(username) {
      if (!this._client) {
        throw new Error("No user pool");
      }
      if (!username) {
        throw new Error("Empty username");
      }
      var clientMetadata = {};
      var user = this.createCognitoUser(username);
      return new Promise(function (resolve, reject) {
        user.resendConfirmationCode(function (err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        }, clientMetadata);
      });
    }
  }, {
    key: "_userSession",
    value: function () {
      var _userSession2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(user) {
        var _this5 = this;
        var clientMetadata, userSession;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (user) {
                _context8.next = 2;
                break;
              }
              throw new Error("the user is null");
            case 2:
              clientMetadata = {}; // Debouncing the concurrent userSession calls by caching the promise.
              // This solution assumes users will always call this function with the same CognitoUser instance.
              if (this._inflightSessionPromiseCounter === 0) {
                this._inflightSessionPromise = new Promise(function (res, rej) {
                  user.getSession( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(err, session) {
                      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                        while (1) switch (_context7.prev = _context7.next) {
                          case 0:
                            if (!err) {
                              _context7.next = 15;
                              break;
                            }
                            if (!_this5.isSessionInvalid(err)) {
                              _context7.next = 11;
                              break;
                            }
                            _context7.prev = 2;
                            _context7.next = 5;
                            return _this5.cleanUpInvalidSession(user);
                          case 5:
                            _context7.next = 11;
                            break;
                          case 7:
                            _context7.prev = 7;
                            _context7.t0 = _context7["catch"](2);
                            rej(new Error("Session is invalid due to: ".concat(err.message, " and failed to clean up invalid session: ").concat(_context7.t0.message)));
                            return _context7.abrupt("return");
                          case 11:
                            rej(err);
                            return _context7.abrupt("return");
                          case 15:
                            res(session);
                            return _context7.abrupt("return");
                          case 17:
                          case "end":
                            return _context7.stop();
                        }
                      }, _callee7, null, [[2, 7]]);
                    }));
                    return function (_x10, _x11) {
                      return _ref2.apply(this, arguments);
                    };
                  }(), {
                    clientMetadata: clientMetadata
                  });
                });
              }
              this._inflightSessionPromiseCounter++;
              _context8.prev = 5;
              _context8.next = 8;
              return this._inflightSessionPromise;
            case 8:
              userSession = _context8.sent;
              user.setSignInUserSession(userSession);
              return _context8.abrupt("return", userSession);
            case 11:
              _context8.prev = 11;
              this._inflightSessionPromiseCounter--;
              return _context8.finish(11);
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[5,, 11, 14]]);
      }));
      function _userSession(_x9) {
        return _userSession2.apply(this, arguments);
      }
      return _userSession;
    }()
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */
  }, {
    key: "authCallbacks",
    value: function authCallbacks(user, resolve, reject) {
      var _this6 = this;
      return {
        onSuccess: function () {
          var _onSuccess2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(session) {
            var currentUser;
            return _regeneratorRuntime().wrap(function _callee9$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  delete user["challengeName"];
                  delete user["challengeParam"];
                  _context9.prev = 2;
                  _context9.next = 5;
                  return _this6._Credentials.clear();
                case 5:
                  _context9.next = 7;
                  return _this6._Credentials.set(session);
                case 7:
                  _context9.next = 11;
                  break;
                case 9:
                  _context9.prev = 9;
                  _context9.t0 = _context9["catch"](2);
                case 11:
                  _context9.prev = 11;
                  _context9.prev = 12;
                  _context9.next = 15;
                  return _this6.currentUserPoolUser();
                case 15:
                  currentUser = _context9.sent;
                  resolve(currentUser);
                  _context9.next = 22;
                  break;
                case 19:
                  _context9.prev = 19;
                  _context9.t1 = _context9["catch"](12);
                  reject(_context9.t1);
                case 22:
                  return _context9.finish(11);
                case 23:
                case "end":
                  return _context9.stop();
              }
            }, _callee9, null, [[2, 9, 11, 23], [12, 19]]);
          }));
          function onSuccess(_x12) {
            return _onSuccess2.apply(this, arguments);
          }
          return onSuccess;
        }(),
        onFailure: function onFailure(err) {
          reject(err);
        },
        customChallenge: function customChallenge(challengeParam) {
          user["challengeName"] = "CUSTOM_CHALLENGE";
          user["challengeParam"] = challengeParam;
          resolve(user);
        },
        mfaRequired: function mfaRequired(challengeName, challengeParam) {
          user["challengeName"] = challengeName;
          user["challengeParam"] = challengeParam;
          resolve(user);
        },
        mfaSetup: function mfaSetup(challengeName, challengeParam) {
          user["challengeName"] = challengeName;
          user["challengeParam"] = challengeParam;
          resolve(user);
        },
        newPasswordRequired: function newPasswordRequired(userAttributes, requiredAttributes) {
          user["challengeName"] = "NEW_PASSWORD_REQUIRED";
          user["challengeParam"] = {
            userAttributes: userAttributes,
            requiredAttributes: requiredAttributes
          };
          resolve(user);
        },
        totpRequired: function totpRequired(challengeName, challengeParam) {
          user["challengeName"] = challengeName;
          user["challengeParam"] = challengeParam;
          resolve(user);
        },
        selectMFAType: function selectMFAType(challengeName, challengeParam) {
          user["challengeName"] = challengeName;
          user["challengeParam"] = challengeParam;
          resolve(user);
        }
      };
    }

    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */
  }, {
    key: "currentUserPoolUser",
    value: function currentUserPoolUser(params) {
      var _this7 = this;
      if (!this._client) {
        throw new Error("No user pool");
      }
      return new Promise(function (res, rej) {
        _this7._storageSync.then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
          var user, clientMetadata;
          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                user = _this7._client.getCurrentUser();
                if (user) {
                  _context12.next = 4;
                  break;
                }
                rej("No current user");
                return _context12.abrupt("return");
              case 4:
                // Unused
                clientMetadata = {}; // refresh the session if the session expired.
                user.getSession( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(err, session) {
                    var bypassCache, _session$getAccessTok, _session$getAccessTok2, scope;
                    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                      while (1) switch (_context11.prev = _context11.next) {
                        case 0:
                          if (!err) {
                            _context11.next = 13;
                            break;
                          }
                          if (!_this7.isSessionInvalid(err)) {
                            _context11.next = 11;
                            break;
                          }
                          _context11.prev = 2;
                          _context11.next = 5;
                          return _this7.cleanUpInvalidSession(user);
                        case 5:
                          _context11.next = 11;
                          break;
                        case 7:
                          _context11.prev = 7;
                          _context11.t0 = _context11["catch"](2);
                          rej(new Error("Session is invalid due to: ".concat(err.message, " and failed to clean up invalid session: ").concat(_context11.t0.message)));
                          return _context11.abrupt("return");
                        case 11:
                          rej(err);
                          return _context11.abrupt("return");
                        case 13:
                          // get user data from Cognito
                          bypassCache = params ? params.bypassCache : false;
                          if (!bypassCache) {
                            _context11.next = 17;
                            break;
                          }
                          _context11.next = 17;
                          return _this7._Credentials.clear();
                        case 17:
                          // validate the token's scope first before calling this function
                          _session$getAccessTok = session.getAccessToken().decodePayload();
                          _session$getAccessTok2 = _session$getAccessTok.scope;
                          scope = _session$getAccessTok2 === void 0 ? "" : _session$getAccessTok2;
                          if (!scope.split(" ").includes(USER_ADMIN_SCOPE)) {
                            _context11.next = 22;
                            break;
                          }
                          user.getUserData( /*#__PURE__*/function () {
                            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(err, data) {
                              var preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                              return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                                while (1) switch (_context10.prev = _context10.next) {
                                  case 0:
                                    if (!(err || !data)) {
                                      _context10.next = 16;
                                      break;
                                    }
                                    if (!_this7.isSessionInvalid(err)) {
                                      _context10.next = 14;
                                      break;
                                    }
                                    _context10.prev = 2;
                                    _context10.next = 5;
                                    return _this7.cleanUpInvalidSession(user);
                                  case 5:
                                    _context10.next = 11;
                                    break;
                                  case 7:
                                    _context10.prev = 7;
                                    _context10.t0 = _context10["catch"](2);
                                    rej(new Error("Session is invalid due to: ".concat(err.message, " and failed to clean up invalid session: ").concat(_context10.t0.message)));
                                    return _context10.abrupt("return");
                                  case 11:
                                    rej(err);
                                    _context10.next = 15;
                                    break;
                                  case 14:
                                    res(user);
                                  case 15:
                                    return _context10.abrupt("return");
                                  case 16:
                                    preferredMFA = data.PreferredMfaSetting || "NOMFA";
                                    attributeList = [];
                                    for (i = 0; i < data.UserAttributes.length; i++) {
                                      attribute = {
                                        Name: data.UserAttributes[i].Name,
                                        Value: data.UserAttributes[i].Value
                                      };
                                      userAttribute = new _amazonCognitoIdentityJs.CognitoUserAttribute(attribute);
                                      attributeList.push(userAttribute);
                                    }
                                    attributes = _this7.attributesToObject(attributeList);
                                    Object.assign(user, {
                                      attributes: attributes,
                                      preferredMFA: preferredMFA
                                    });
                                    return _context10.abrupt("return", res(user));
                                  case 22:
                                  case "end":
                                    return _context10.stop();
                                }
                              }, _callee10, null, [[2, 7]]);
                            }));
                            return function (_x15, _x16) {
                              return _ref5.apply(this, arguments);
                            };
                          }(), {
                            bypassCache: bypassCache,
                            clientMetadata: clientMetadata
                          });
                          _context11.next = 23;
                          break;
                        case 22:
                          return _context11.abrupt("return", res(user));
                        case 23:
                        case "end":
                          return _context11.stop();
                      }
                    }, _callee11, null, [[2, 7]]);
                  }));
                  return function (_x13, _x14) {
                    return _ref4.apply(this, arguments);
                  };
                }(), {
                  clientMetadata: clientMetadata
                });
              case 6:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        })))["catch"](function (e) {
          return rej(e);
        });
      });
    }

    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */
  }, {
    key: "signInWithPassword",
    value: function signInWithPassword(authDetails) {
      var _this8 = this;
      if (this._pendingSignIn) {
        throw new Error("Pending sign-in attempt already in progress");
      }
      var user = this.createCognitoUser(authDetails.getUsername());
      this._pendingSignIn = new Promise(function (resolve, reject) {
        user.authenticateUser(authDetails, _this8.authCallbacks(user, function (value) {
          _this8._pendingSignIn = null;
          resolve(value);
        }, function (error) {
          _this8._pendingSignIn = null;
          reject(error);
        }));
      });
      return this._pendingSignIn;
    }

    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */
  }, {
    key: "signInWithoutPassword",
    value: function signInWithoutPassword(authDetails) {
      var _this9 = this;
      var session = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!session) {
        throw new Error("Invalid session");
      }
      var user = this.createCognitoUser(authDetails.getUsername());
      user.setSignInUserSession(session);
      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(resolve, reject) {
          var currentUser;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                delete user["challengeName"];
                delete user["challengeParam"];
                _context13.next = 4;
                return _this9._Credentials.clear();
              case 4:
                _context13.next = 6;
                return _this9._Credentials.set(session);
              case 6:
                _context13.prev = 6;
                _context13.next = 9;
                return _this9.currentUserPoolUser();
              case 9:
                currentUser = _context13.sent;
                resolve(currentUser);
                _context13.next = 16;
                break;
              case 13:
                _context13.prev = 13;
                _context13.t0 = _context13["catch"](6);
                reject(_context13.t0);
              case 16:
              case "end":
                return _context13.stop();
            }
          }, _callee13, null, [[6, 13]]);
        }));
        return function (_x17, _x18) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "signInWithJwtToken",
    value: function () {
      var _signInWithJwtToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(username, accessToken, idToken, refreshToken) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.signin(username, "", new _amazonCognitoIdentityJs.CognitoUserSession({
                AccessToken: new _amazonCognitoIdentityJs.CognitoAccessToken({
                  AccessToken: accessToken
                }),
                IdToken: new _amazonCognitoIdentityJs.CognitoIdToken({
                  IdToken: idToken
                }),
                RefreshToken: new _amazonCognitoIdentityJs.CognitoRefreshToken({
                  RefreshToken: refreshToken
                })
              }));
            case 2:
              return _context14.abrupt("return", _context14.sent);
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function signInWithJwtToken(_x19, _x20, _x21, _x22) {
        return _signInWithJwtToken.apply(this, arguments);
      }
      return signInWithJwtToken;
    }()
  }, {
    key: "signin",
    value: function () {
      var _signin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(email, password) {
        var session,
          authDetails,
          _args15 = arguments;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              session = _args15.length > 2 && _args15[2] !== undefined ? _args15[2] : null;
              if (!this._pendingSignIn) {
                _context15.next = 3;
                break;
              }
              throw new Error("Pending sign-in attempt already in progress");
            case 3:
              // Save email in class to minimise function params as we persist
              // through the sign in process.
              this._email = email;
              authDetails = new _amazonCognitoIdentityJs.AuthenticationDetails({
                Username: email,
                Password: password
              });
              if (!password) {
                _context15.next = 9;
                break;
              }
              return _context15.abrupt("return", this.signInWithPassword(authDetails));
            case 9:
              return _context15.abrupt("return", this.signInWithoutPassword(authDetails, session));
            case 10:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function signin(_x23, _x24) {
        return _signin.apply(this, arguments);
      }
      return signin;
    }()
  }, {
    key: "cognitoIdentitySignOut",
    value: function () {
      var _cognitoIdentitySignOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(user) {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return this._storageSync;
            case 3:
              _context16.next = 8;
              break;
            case 5:
              _context16.prev = 5;
              _context16.t0 = _context16["catch"](0);
              throw _context16.t0;
            case 8:
              return _context16.abrupt("return", new Promise(function (res, rej) {
                user.signOut(function () {
                  return res(null);
                });
              }));
            case 9:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this, [[0, 5]]);
      }));
      function cognitoIdentitySignOut(_x25) {
        return _cognitoIdentitySignOut.apply(this, arguments);
      }
      return cognitoIdentitySignOut;
    }()
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */
  }, {
    key: "signout",
    value: (function () {
      var _signout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var user;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.cleanCachedItems();
            case 2:
              if (!this._client) {
                _context17.next = 7;
                break;
              }
              user = this._client.getCurrentUser();
              if (!user) {
                _context17.next = 7;
                break;
              }
              _context17.next = 7;
              return this.cognitoIdentitySignOut(user);
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function signout() {
        return _signout.apply(this, arguments);
      }
      return signout;
    }())
  }, {
    key: "resendSignup",
    value: function () {
      var _resendSignup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(email, password) {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              this._email = email;
              this._password = password;
              this._confirmSignUp = true;
              _context18.next = 6;
              return this._resendSignUp(email);
            case 6:
              return _context18.abrupt("return", true);
            case 9:
              _context18.prev = 9;
              _context18.t0 = _context18["catch"](0);
              return _context18.abrupt("return", false);
            case 12:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this, [[0, 9]]);
      }));
      function resendSignup(_x26, _x27) {
        return _resendSignup.apply(this, arguments);
      }
      return resendSignup;
    }()
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var user;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              user = this._client.getCurrentUser();
              return _context19.abrupt("return", user);
            case 2:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getUser() {
        return _getUser.apply(this, arguments);
      }
      return getUser;
    }()
  }, {
    key: "isAuthenticated",
    value: function () {
      var _isAuthenticated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var user;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              user = this._client.getCurrentUser();
              if (!user) {
                _context20.next = 4;
                break;
              }
              return _context20.abrupt("return", true);
            case 4:
              return _context20.abrupt("return", false);
            case 7:
              _context20.prev = 7;
              _context20.t0 = _context20["catch"](0);
              return _context20.abrupt("return", false);
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this, [[0, 7]]);
      }));
      function isAuthenticated() {
        return _isAuthenticated.apply(this, arguments);
      }
      return isAuthenticated;
    }()
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */
  }, {
    key: "forgotPassword",
    value: function forgotPassword(username) {
      if (!this._client) {
        throw new Error("no user pool");
      }
      if (!username) {
        throw new Error("no user name");
      }
      var clientMetadata = {};
      this._email = username;
      var user = this.createCognitoUser(username);
      return new Promise(function (resolve, reject) {
        user.forgotPassword({
          onSuccess: function onSuccess() {
            resolve(null);
            return;
          },
          onFailure: function onFailure(err) {
            reject(err);
            return;
          },
          inputVerificationCode: function inputVerificationCode(data) {
            resolve(data);
            return;
          }
        }, clientMetadata);
      });
    }

    /**
     * Confirm a new password using a confirmation Code
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */
  }, {
    key: "forgotPasswordSubmit",
    value: (function () {
      var _forgotPasswordSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(code, password) {
        var username, clientMetadata, user;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (this._client) {
                _context21.next = 2;
                break;
              }
              throw new Error("No userpool");
            case 2:
              username = this._email;
              if (username) {
                _context21.next = 5;
                break;
              }
              throw new Error("Empty username");
            case 5:
              if (code) {
                _context21.next = 7;
                break;
              }
              throw new Error("Empty code");
            case 7:
              if (password) {
                _context21.next = 9;
                break;
              }
              throw new Error("Empty password");
            case 9:
              clientMetadata = {};
              user = this.createCognitoUser(username);
              _context21.next = 13;
              return new Promise(function (resolve, reject) {
                user.confirmPassword(code, password, {
                  onSuccess: function onSuccess(success) {
                    resolve(success);
                    return;
                  },
                  onFailure: function onFailure(err) {
                    reject(err);
                    return;
                  }
                }, clientMetadata);
              });
            case 13:
              return _context21.abrupt("return", _context21.sent);
            case 14:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function forgotPasswordSubmit(_x28, _x29) {
        return _forgotPasswordSubmit.apply(this, arguments);
      }
      return forgotPasswordSubmit;
    }())
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(code, password) {
        var res;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;
              _context22.next = 3;
              return this.forgotPasswordSubmit(code, password);
            case 3:
              res = _context22.sent;
              if (!(res !== "SUCCESS")) {
                _context22.next = 6;
                break;
              }
              return _context22.abrupt("return", false);
            case 6:
              this._email = undefined;
              return _context22.abrupt("return", true);
            case 10:
              _context22.prev = 10;
              _context22.t0 = _context22["catch"](0);
              return _context22.abrupt("return", false);
            case 13:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this, [[0, 10]]);
      }));
      function resetPassword(_x30, _x31) {
        return _resetPassword.apply(this, arguments);
      }
      return resetPassword;
    }()
  }, {
    key: "completeNewPassword",
    value: function () {
      var _completeNewPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(user, password) {
        var _this10 = this;
        var clientMetadata, res;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              if (password) {
                _context23.next = 3;
                break;
              }
              throw new Error("No password given");
            case 3:
              clientMetadata = {};
              _context23.next = 6;
              return new Promise(function (resolve, reject) {
                return user.completeNewPasswordChallenge(password, {}, _this10.authCallbacks(user, function (value) {
                  resolve(value);
                }, function (error) {
                  reject(error);
                }), clientMetadata);
              });
            case 6:
              res = _context23.sent;
              return _context23.abrupt("return", res);
            case 10:
              _context23.prev = 10;
              _context23.t0 = _context23["catch"](0);
              return _context23.abrupt("return", false);
            case 13:
            case "end":
              return _context23.stop();
          }
        }, _callee23, null, [[0, 10]]);
      }));
      function completeNewPassword(_x32, _x33) {
        return _completeNewPassword.apply(this, arguments);
      }
      return completeNewPassword;
    }()
  }, {
    key: "confirmAccount",
    value: function () {
      var _confirmAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(cognitoUser, code) {
        var res, confirmRes, confirmSignInRes;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;
              if (!this._confirmSignUp) {
                _context24.next = 11;
                break;
              }
              _context24.next = 4;
              return this.confirmSignUp(this._email,
              // this is safe at this point as it was set in the resend sign up email
              code);
            case 4:
              confirmRes = _context24.sent;
              if (!confirmRes) {
                _context24.next = 9;
                break;
              }
              _context24.next = 8;
              return this.signin(this._email, this._password);
            case 8:
              res = _context24.sent;
            case 9:
              _context24.next = 18;
              break;
            case 11:
              _context24.next = 13;
              return this.confirmSignIn(cognitoUser, code, "SMS_MFA");
            case 13:
              confirmSignInRes = _context24.sent;
              if (!confirmSignInRes) {
                _context24.next = 18;
                break;
              }
              _context24.next = 17;
              return this.currentUserPoolUser();
            case 17:
              res = _context24.sent;
            case 18:
              return _context24.abrupt("return", res);
            case 21:
              _context24.prev = 21;
              _context24.t0 = _context24["catch"](0);
              return _context24.abrupt("return", false);
            case 24:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this, [[0, 21]]);
      }));
      function confirmAccount(_x34, _x35) {
        return _confirmAccount.apply(this, arguments);
      }
      return confirmAccount;
    }()
  }]);
  return AuthService;
}();